import type { AgentEdge, AgentNode } from '@saaga/shared/interfaces/agency-node.interface'
import { useCallback, useState } from 'react'

interface UseAgencyFlowSelectionReturn {
  selectedNodeId: string | null
  selectedNode: AgentNode | null
  selectedEdgeId: string | null
  selectedEdge: AgentEdge | null
  onNodeClick: (nodeId: string) => void
  onEdgeClick: (edgeId: string) => void
  clearSelection: () => void
  setSelectedNodeId: (nodeId: string | null) => void
}

export const useAgencyFlowSelection = (
  nodeList: AgentNode[],
  edgeList: AgentEdge[]
): UseAgencyFlowSelectionReturn => {
  const [selectedNodeId, setSelectedNodeId] = useState<string | null>(null)
  const [selectedEdgeId, setSelectedEdgeId] = useState<string | null>(null)

  const selectedNode = nodeList.find((node) => node.id === selectedNodeId) ?? null
  const selectedEdge = edgeList.find((edge) => edge.id === selectedEdgeId) ?? null

  const onNodeClick = useCallback((nodeId: string): void => {
    setSelectedNodeId(nodeId)
    setSelectedEdgeId(null)
  }, [])

  const onEdgeClick = useCallback((edgeId: string): void => {
    setSelectedEdgeId(edgeId)
    setSelectedNodeId(null)
  }, [])

  const clearSelection = useCallback((): void => {
    setSelectedNodeId(null)
    setSelectedEdgeId(null)
  }, [])

  return {
    selectedNodeId,
    selectedNode,
    selectedEdgeId,
    selectedEdge,
    onNodeClick,
    onEdgeClick,
    clearSelection,
    setSelectedNodeId,
  }
}
